<template>
  <div class="container wow fadeInUp" v-if="itemPortal.length != 0">
    <div class="portal__title sp">
      <img src="@/assets/img/top/portal_icon.svg" alt="" />
      周辺施設
    </div>
    <div class="portal__holder">
      <div class="portal__title pc">
        <img src="@/assets/img/top/portal_icon.svg" alt="" />
        周辺施設
      </div>
      <div class="portal__list">
        <div class="portal__list__item" v-for="(item, index) in itemPortal" :key="index">
          <a target="_blank" :href="item.acf?.link_url">
            <img
              class="link_img"
              v-if="item.acf?.thumb_image || item.acf?.title"
              :src="$func.formatUrl(item.acf?.thumb_image)"
              :alt="item.acf?.title"
            />
            <span v-if="item.acf?.title" v-html="item.acf?.title"></span>
            <img
              class="link_icon"
              src="@/assets/img/top//portal_link_icon.svg"
              alt="portal_link_icon"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CONSTANT from "../../constant";
import { getUrl } from '@/utils/helper';

export default {
  name: "ItemEvent",
  components: {},
  data() {
    return {
      itemPortal: [],
      listFilter: CONSTANT.dataFilter[0],
      isLoading: true,
    };
  },
  computed: {},
  created() {
    this.isLoading = true;
    getUrl('/link_sf')
    .then((response) => {
      var filtered = this.$func.filterByDeliveryMedia(response.data, [this.listFilter.town,this.listFilter.all]);
      var sorted = this.$func.sortByNumberKey(filtered, 'display_order');
      this.itemPortal = JSON.parse(JSON.stringify(sorted));
      this.isLoading = false;
    })
    .catch((e) => {
      console.log(e);
    });
  },
};
</script>
